import DigitalCuratorship from '../../shared/digitalCuratorship/DigitalCuratorship';
import classes from './Curatorship.module.css';

const Curatorship = () => {
    return (
        <div className={classes.Curatorship}>
            <DigitalCuratorship />
        </div>
    )
}
export default Curatorship;